<template>
  <div class="win">
    <div class="win_title">
        <h3>恭喜您获得</h3>
        <span>{{name}}</span>
        储值大礼
    </div>
    <img class="win_img" src="/activity/turntable/img/win.png">
  </div>
</template>

<script>
    export default {
        name:'Winning',
        props:['name']
    }
</script>

<style scoped>
    .win{
        display: none;
        position: relative;
        width: 100%;
    }
    .win_img{
        position: relative;
        top: 0;
        left: 0;
        z-index: -10;
    }
    .win_title{
        font-size: 24px;
        color: #912C2C;
        position: absolute;
        left: 50%;
        top: 43%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
    .win_title h3{
        font-size: 24px;
        margin: 0;
    }
    .win_title span{
        font-weight: bold;
        font-size: 30px;
    }
    .layui-layer{
        background-color: transparent !important;
        box-shadow: none !important;
    }
</style>